var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    {
      staticClass: "k-sort-filter-menu k-number-filter-menu",
      attrs: { subheader: "" }
    },
    [
      _vm.sortable
        ? _c(
            "div",
            [
              _c("v-subheader", [_vm._v("Sorting:")]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      class: _vm.sort.asc,
                      attrs: { flat: "", color: "info" },
                      on: {
                        mousedown: function($event) {
                          return _vm.handleSortClick("asc")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "k-sort-icon-container" },
                            [
                              _vm._v("\n            0-9\n            "),
                              _c("v-icon", [_vm._v("straight")])
                            ],
                            1
                          ),
                          _vm._v("\n          Ascending\n        ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "k-operation-check-icon",
                          attrs: { color: "primary" }
                        },
                        [_vm._v("check")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      class: _vm.sort.desc,
                      attrs: { flat: "", color: "info" },
                      on: {
                        mousedown: function($event) {
                          return _vm.handleSortClick("desc")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "k-sort-icon-container" },
                            [
                              _vm._v("\n            9-0\n            "),
                              _c("v-icon", { staticClass: "inverted" }, [
                                _vm._v("straight")
                              ])
                            ],
                            1
                          ),
                          _vm._v("\n          Descending\n        ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "k-operation-check-icon",
                          attrs: { color: "primary" }
                        },
                        [_vm._v("check")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-subheader", [_vm._v("Filter:")]),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("span", { attrs: { "data-options": "filter" } }, [
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.operator.eq,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleOperatorClick("Date is exactly", "eq")
                  }
                }
              },
              [
                _vm._v("\n        Date is exactly\n        "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "primary" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.operator.lte,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleOperatorClick("Date is before", "lt")
                  }
                }
              },
              [
                _vm._v("\n        Date is before\n        "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "primary" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.operator.gte,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleOperatorClick("Date is after", "gt")
                  }
                }
              },
              [
                _vm._v("\n        Date is after\n        "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "primary" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.intervals.week,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleDateClick(
                      "week",
                      "Last 7 days",
                      _vm.isUtcTime
                    )
                  }
                }
              },
              [
                _vm._v("\n        Last 7 days\n        "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "primary" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.intervals.month,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleDateClick(
                      "month",
                      "Last 30 days",
                      _vm.isUtcTime
                    )
                  }
                }
              },
              [
                _vm._v("\n        Last 30 days\n        "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "primary" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.intervals.quarter,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleDateClick(
                      "quarter",
                      "Last 3 months",
                      _vm.isUtcTime
                    )
                  }
                }
              },
              [
                _vm._v("\n        Last 3 months\n        "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "primary" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.intervals.year,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleDateClick(
                      "year",
                      "Last year",
                      _vm.isUtcTime
                    )
                  }
                }
              },
              [
                _vm._v("\n        Last year\n        "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "primary" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("v-divider", {
        staticStyle: { "margin-top": "4px", "margin-bottom": "2px" }
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }